import { SVGProps, Ref, forwardRef } from 'react';

export const VideocameraHyperstarOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M11 2c4.273 0 6.517 1.014 7.455 3.766q.273.801.404 1.808L22.04 6H24v12h-1.96l-3.18-1.574a9.5 9.5 0 0 1-.405 1.808C17.517 20.986 15.273 22 11 22H8c-6 0-8-2-8-8v-3h1.8v3c0 2.9.506 4.261 1.222 4.977C3.74 19.694 5.1 20.2 8 20.2h3c2.453 0 3.816-.363 4.61-.916.693-.483 1.23-1.315 1.465-3.094l.33-2.493L22.2 16.07V7.93l-4.795 2.373-.33-2.492c-.235-1.78-.772-2.612-1.466-3.095C14.816 4.163 13.453 3.8 11 3.8H9V2z"
                    fill="currentColor"
                />
                <path
                    d="M3.5 2A13.3 13.3 0 0 0 7 5.5 13.3 13.3 0 0 0 3.5 9 13.3 13.3 0 0 0 0 5.5 13.3 13.3 0 0 0 3.5 2"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
VideocameraHyperstarOutlinedSize24Glyph.displayName = 'VideocameraHyperstarOutlinedSize24Glyph';
